module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-text-reece.c9cebce.png";